import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CommonAuthRoutingModule } from './common-auth-routing.module';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { CommonAuthService } from './common-auth.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth-interceptor.interceptor';
import { AddArticleArabicComponent } from '../add-article-arabic/add-article-arabic.component';

@NgModule({
  declarations: [LoginComponent, RegisterComponent, ForgotPasswordComponent,AddArticleArabicComponent],
  imports: [
    CommonModule,
    CommonAuthRoutingModule,
  ],
  providers: [
    CommonAuthService,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ]
})
export class CommonAuthModule { }
